if (document.querySelectorAll(".square-card-wrapper").length > 0) {
  const ui = {
    squareCardWrappers: document.querySelectorAll('.square-card-wrapper[adaptive-height="parent"]'),
  }

  console.log(ui.squareCardWrappers)
}